import React from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import BaseWholesaleController from "./BaseWholesaleController";
import NtRootPageContainer from "../../root/components/NtRootPageContainer";
import ipcsvcolumndata from "../data/ipcsvcolumndata";
import { fetchWholesaleIps } from "../../api/wholesale";
import Logger from "../../common/utils/Logger";
import { parseUrlParam } from "../../common/utils/ControllerUtils";
import settings from "../../config/settings";

class IPController extends BaseWholesaleController {
  state = {};

  column_location = "@ips_column_storage";

  page = 1;

  componentDidMount() {
    this.didFocusListener = this.props.navigation.addListener(
      "focus",
      this.handleFocus
    );

    this.handleDefaultColumnsFetch(
      this.column_location,
      ipcsvcolumndata.filter((each) => each.default == true)
    );

    this.handleDataFetch();
  }

  componentDidUpdate(prevProps) {
    // Check if the params have changed

    if (prevProps.route.params !== this.props.route.params) {
      this.page = 1;
      this.handleDataFetch();
    }
  }

  componentWillUnmount() {
    // Remove the event listener
    this.didFocusListener();
  }

  handleFocus = () => {
    Logger("IP Controller focused params:", this.props.route);
  };

  handleDataFetch = async () => {
    Logger("Fetching Dids data");

    this.setState({ loading: true });

    const deviceId = parseUrlParam(this.props.route?.params?.deviceid);
    const response = await fetchWholesaleIps(
      this.context.user?.user?.id,
      deviceId,
      this.page,
      settings.pageSizeLoad
    );

    Logger("Data response GET: ", response);

    if (response.ok) {
      if (this.page == 1) {
        Logger("Loading for the first time.");
        this.setState({
          data: response.data?._embedded?.dids,
          totalItems: response.data?.total_items,
        });
      } else {
        Logger("Loading more.");

        this.setState({
          data: this.state.data.concat(response.data?._embedded?.dids),
        });
      }
    }
    this.setState({ loading: false });
  };

  render() {
    return (
      <NtRootPageContainer
        style={styles.container}
        pageTitle={"Whitelist IPs"}
      ></NtRootPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
});

export default IPController;
